// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Карточка и хедер === */
.TimelineBlock_card__K6Ww6 {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  display: flex;
  flex-direction: column;

  /* глобально глушим выделение внутри карточки */
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.TimelineBlock_card__K6Ww6 * {
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.TimelineBlock_header__2CJSI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #f3f4f6;
}

.TimelineBlock_title__NenoZ {
  font-weight: 800;
  color: #111827;
}

/* === Контролы хедера === */
.TimelineBlock_headerControls__aJ2P6 {
  display: flex;
  gap: 12px;
  align-items: center;
}

.TimelineBlock_chk__cDOKU {
  display: inline-flex;
  gap: 8px;
  font-size: 14px;
  color: #374151;
}

.TimelineBlock_btn__Yl9R7 {
  font-size: 13px;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  background: #fafafb;
  border-radius: 8px;
  cursor: pointer;
}
.TimelineBlock_btn__Yl9R7:hover { background: #f3f4f6; }

/* === Скролл-область === */
.TimelineBlock_scrollArea__pwNVL {
  overflow: hidden;
  overscroll-behavior: contain;
  position: relative;
}

/* Принудительный запрет выделения (дублируется для совместимости с логикой noSelect) */
.TimelineBlock_noSelect__JxsBj,
.TimelineBlock_noSelect__JxsBj * {
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

/* === Верхняя шкала (sticky) === */
.TimelineBlock_ticksRow__v80DZ {
  position: sticky;
  top: 0;
  z-index: 2;
  height: 32px;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
}

.TimelineBlock_gridHost__Xt0\\+Q {
  position: relative;
  height: 100%;
}

/* Деления времени */
.TimelineBlock_tick__k6PnB {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  text-align: center;
}
.TimelineBlock_tickLabel__pjAwX {
  display: inline-block;
  font-size: 11px;
  color: #6b7280;
  background: #fff;
  padding: 0 4px;
}
.TimelineBlock_vline__50Lt0 {
  position: absolute;
  top: 18px;
  left: 50%;
  width: 1px;
  height: calc(100% - 18px);
  background: #e5e7eb;
}

/* === Сетка строк: 2 колонки — label + timeline === */
.TimelineBlock_rowsGrid__d5nh0 {
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: stretch;
}

/* Строка — контейнер для 2 ячеек (grid) */
.TimelineBlock_row__TnEux {
  display: contents;
}

/* Левая ячейка — маршрут */
.TimelineBlock_labelCell__uQULU {
  position: sticky;
  left: 0;
  z-index: 1;
  text-align: left;

  appearance: none;
  -webkit-appearance: none;
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;

  padding: 8px 12px;
  color: #374151;
  font-weight: 500;
  cursor: pointer;
}
.TimelineBlock_labelCell__uQULU:hover { background: transparent; color: #111827; }
.TimelineBlock_labelCell__uQULU:focus { outline: none; }
.TimelineBlock_labelCell__uQULU::-moz-focus-inner { border: 0; }

/* Правая ячейка — таймлиния */
.TimelineBlock_gridCell__TY9uy {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
}

/* Горизонтальная линия строки */
.TimelineBlock_hline__uxHvx {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1px;
  background: #f1f5f9;
  transform: translateY(-50%);
}

/* Контейнер для маркеров поверх hline */
.TimelineBlock_gridCell__TY9uy .TimelineBlock_gridHost__Xt0\\+Q {
  position: absolute;
  inset: 0;
}

/* Маркер события */
.TimelineBlock_marker__ozHlx {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 999px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  cursor: pointer;
}

/* Тултип */
.TimelineBlock_tooltip__C\\+AzD {
  position: absolute;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  background: #111827;
  color: #fff;
  font-size: 12px;
  line-height: 1.25;
  padding: 8px 10px;
  border-radius: 8px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity .12s ease;
}
.TimelineBlock_marker__ozHlx:hover .TimelineBlock_tooltip__C\\+AzD { opacity: 1; }

/* Состояние drag */
.TimelineBlock_dragging__cD4fO { cursor: grabbing !important; }

/* Пусто */
.TimelineBlock_empty__IeEe2 {
  grid-column: 1 / -1;
  text-align: center;
  color: #9ca3af;
  padding: 16px 0 20px;
}

/* Подвал */
.TimelineBlock_footerHint__pJ5Ow {
  padding: 8px 12px 10px;
  color: #6b7280;
  font-size: 12px;
  border-top: 1px solid #f3f4f6;
}

/* === Пагинация === */
.TimelineBlock_pagination__pnYj7 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 13px;
  color: #374151;
  flex: 1 1;
}

.TimelineBlock_pageBtn__zMsAm {
  border: 1px solid #e5e7eb;
  background: #fafafa;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.TimelineBlock_pageBtn__zMsAm:hover:not(:disabled) {
  background: #f3f4f6;
}
.TimelineBlock_pageBtn__zMsAm:disabled {
  opacity: 0.4;
  cursor: default;
}

`, "",{"version":3,"sources":["webpack://./src/modules/Manager/RouteProgressDetails/components/TimelineBlock.module.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;;EAEtB,+CAA+C;EAC/C,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA,kCAAa,mBAAmB,EAAE;;AAElC,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,uFAAuF;AACvF;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,MAAM;EACN,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,gBAAgB;;EAEhB,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;;EAEvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,wCAAmB,uBAAuB,EAAE,cAAc,EAAE;AAC5D,wCAAmB,aAAa,EAAE;AAClC,oDAA+B,SAAS,EAAE;;AAE1C,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;AACA,oEAAyB,UAAU,EAAE;;AAErC,mBAAmB;AACnB,iCAAY,2BAA2B,EAAE;;AAEzC,UAAU;AACV;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* === Карточка и хедер === */\r\n.card {\r\n  background: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  /* глобально глушим выделение внутри карточки */\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n.card * {\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n}\r\n\r\n.title {\r\n  font-weight: 800;\r\n  color: #111827;\r\n}\r\n\r\n/* === Контролы хедера === */\r\n.headerControls {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.chk {\r\n  display: inline-flex;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  color: #374151;\r\n}\r\n\r\n.btn {\r\n  font-size: 13px;\r\n  padding: 6px 10px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #fafafb;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n.btn:hover { background: #f3f4f6; }\r\n\r\n/* === Скролл-область === */\r\n.scrollArea {\r\n  overflow: hidden;\r\n  overscroll-behavior: contain;\r\n  position: relative;\r\n}\r\n\r\n/* Принудительный запрет выделения (дублируется для совместимости с логикой noSelect) */\r\n.noSelect,\r\n.noSelect * {\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n/* === Верхняя шкала (sticky) === */\r\n.ticksRow {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n  height: 32px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  background: #fff;\r\n}\r\n\r\n.gridHost {\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n\r\n/* Деления времени */\r\n.tick {\r\n  position: absolute;\r\n  top: 0;\r\n  transform: translateX(-50%);\r\n  text-align: center;\r\n}\r\n.tickLabel {\r\n  display: inline-block;\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  background: #fff;\r\n  padding: 0 4px;\r\n}\r\n.vline {\r\n  position: absolute;\r\n  top: 18px;\r\n  left: 50%;\r\n  width: 1px;\r\n  height: calc(100% - 18px);\r\n  background: #e5e7eb;\r\n}\r\n\r\n/* === Сетка строк: 2 колонки — label + timeline === */\r\n.rowsGrid {\r\n  display: grid;\r\n  grid-template-columns: 200px 1fr;\r\n  align-items: stretch;\r\n}\r\n\r\n/* Строка — контейнер для 2 ячеек (grid) */\r\n.row {\r\n  display: contents;\r\n}\r\n\r\n/* Левая ячейка — маршрут */\r\n.labelCell {\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 1;\r\n  text-align: left;\r\n\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: none;\r\n  background: transparent;\r\n\r\n  padding: 8px 12px;\r\n  color: #374151;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n}\r\n.labelCell:hover { background: transparent; color: #111827; }\r\n.labelCell:focus { outline: none; }\r\n.labelCell::-moz-focus-inner { border: 0; }\r\n\r\n/* Правая ячейка — таймлиния */\r\n.gridCell {\r\n  position: relative;\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Горизонтальная линия строки */\r\n.hline {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 50%;\r\n  height: 1px;\r\n  background: #f1f5f9;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n/* Контейнер для маркеров поверх hline */\r\n.gridCell .gridHost {\r\n  position: absolute;\r\n  inset: 0;\r\n}\r\n\r\n/* Маркер события */\r\n.marker {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 999px;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\r\n  cursor: pointer;\r\n}\r\n\r\n/* Тултип */\r\n.tooltip {\r\n  position: absolute;\r\n  bottom: 14px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: #111827;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  line-height: 1.25;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity .12s ease;\r\n}\r\n.marker:hover .tooltip { opacity: 1; }\r\n\r\n/* Состояние drag */\r\n.dragging { cursor: grabbing !important; }\r\n\r\n/* Пусто */\r\n.empty {\r\n  grid-column: 1 / -1;\r\n  text-align: center;\r\n  color: #9ca3af;\r\n  padding: 16px 0 20px;\r\n}\r\n\r\n/* Подвал */\r\n.footerHint {\r\n  padding: 8px 12px 10px;\r\n  color: #6b7280;\r\n  font-size: 12px;\r\n  border-top: 1px solid #f3f4f6;\r\n}\r\n\r\n/* === Пагинация === */\r\n.pagination {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  font-size: 13px;\r\n  color: #374151;\r\n  flex: 1;\r\n}\r\n\r\n.pageBtn {\r\n  border: 1px solid #e5e7eb;\r\n  background: #fafafa;\r\n  border-radius: 6px;\r\n  width: 28px;\r\n  height: 28px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n.pageBtn:hover:not(:disabled) {\r\n  background: #f3f4f6;\r\n}\r\n.pageBtn:disabled {\r\n  opacity: 0.4;\r\n  cursor: default;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `TimelineBlock_card__K6Ww6`,
	"header": `TimelineBlock_header__2CJSI`,
	"title": `TimelineBlock_title__NenoZ`,
	"headerControls": `TimelineBlock_headerControls__aJ2P6`,
	"chk": `TimelineBlock_chk__cDOKU`,
	"btn": `TimelineBlock_btn__Yl9R7`,
	"scrollArea": `TimelineBlock_scrollArea__pwNVL`,
	"noSelect": `TimelineBlock_noSelect__JxsBj`,
	"ticksRow": `TimelineBlock_ticksRow__v80DZ`,
	"gridHost": `TimelineBlock_gridHost__Xt0+Q`,
	"tick": `TimelineBlock_tick__k6PnB`,
	"tickLabel": `TimelineBlock_tickLabel__pjAwX`,
	"vline": `TimelineBlock_vline__50Lt0`,
	"rowsGrid": `TimelineBlock_rowsGrid__d5nh0`,
	"row": `TimelineBlock_row__TnEux`,
	"labelCell": `TimelineBlock_labelCell__uQULU`,
	"gridCell": `TimelineBlock_gridCell__TY9uy`,
	"hline": `TimelineBlock_hline__uxHvx`,
	"marker": `TimelineBlock_marker__ozHlx`,
	"tooltip": `TimelineBlock_tooltip__C+AzD`,
	"dragging": `TimelineBlock_dragging__cD4fO`,
	"empty": `TimelineBlock_empty__IeEe2`,
	"footerHint": `TimelineBlock_footerHint__pJ5Ow`,
	"pagination": `TimelineBlock_pagination__pnYj7`,
	"pageBtn": `TimelineBlock_pageBtn__zMsAm`
};
export default ___CSS_LOADER_EXPORT___;
